import React, { useRef } from 'react';
import styled from 'astroturf/react';
import useOnClickOutside from 'js/utils/hooks/useOnClickOutside';
import useScrollLock from 'js/utils/hooks/useScrollLock';
import ToolsMenu, {
  Props as ToolsMenuProps,
} from 'js/header/FocusedNav/ToolsMenu';

const Background = styled.div`
  position: absolute;
  top: var(--nav-desktop-height);
  left: 0;
  width: 100vw;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.6);
  z-index: -1;
`;

const Container = styled.div`
  position: absolute;

  min-height: 100%;
  width: 400px;
  max-width: 80vw;

  right: 0;
  background: white;

  padding: 12px 12px 48px;
`;

type Props = ToolsMenuProps & {
  close: () => void;
  buttonRef: React.RefObject<HTMLButtonElement>;
  navHeight: number;
};

const ToolsSidebar = ({ close, buttonRef, navHeight, ...restProps }: Props) => {
  useScrollLock();

  const containerRef = useRef<HTMLDivElement>(null);

  useOnClickOutside([buttonRef, containerRef], close);

  const onClose = (event: React.MouseEvent) => {
    if (event.target === event.currentTarget) {
      close();
    }
  };

  return (
    <Background
      onClick={onClose}
      style={{ height: `calc(100vh - ${navHeight}px)` }}
    >
      <Container ref={containerRef}>
        <ToolsMenu {...restProps} />
      </Container>
    </Background>
  );
};

export default ToolsSidebar;
